var map = {
	"./yellow.png": "fcot",
	"./yellow1.png": "9PO5",
	"./yellow2.png": "ZN9S",
	"./yellowqita.png": "tKdh"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "gI1p";


//////////////////
// WEBPACK FOOTER
// ./src/views/rescuelist/img/list ^\.\/yellow.*\.png$
// module id = gI1p
// module chunks = 1